import React, { useState } from 'react';

const panelStyle = {
  width: 280,
  background: '#1a1a2e',
  borderLeft: '1px solid rgba(102,126,234,0.15)',
  padding: 16,
  overflowY: 'auto',
  color: '#eee',
  fontFamily: 'sans-serif',
  borderRadius: '8px 0 0 8px',
};

const cropBtnStyle = {
  padding: '10px 16px',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 600,
  width: '100%',
  marginTop: 16,
  transition: 'opacity 0.2s',
};

const inputStyle = {
  width: 60,
  padding: '6px 8px',
  background: '#0f0f1a',
  color: '#eee',
  border: '1px solid #333',
  borderRadius: 6,
  fontSize: 12,
  textAlign: 'center',
  outline: 'none',
};

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 8,
};

const labelStyle = {
  fontSize: 11,
  color: '#888',
  width: 50,
};

const presetBtnStyle = (active) => ({
  padding: '6px 12px',
  background: active ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#0f0f1a',
  color: active ? '#fff' : '#999',
  border: active ? 'none' : '1px solid #333',
  borderRadius: 6,
  cursor: 'pointer',
  fontSize: 11,
  fontWeight: active ? 600 : 400,
  transition: 'all 0.2s',
});

const PRESETS = [
  { label: 'Free', ratio: null },
  { label: '1:1', ratio: 1 },
  { label: '4:3', ratio: 4 / 3 },
  { label: '16:9', ratio: 16 / 9 },
  { label: '3:2', ratio: 3 / 2 },
];

export default function CropPanel({ editor }) {
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [width, setWidth] = useState(100);
  const [height, setHeight] = useState(100);
  const [activePreset, setActivePreset] = useState('Free');

  const handlePreset = (preset) => {
    setActivePreset(preset.label);
    if (preset.ratio) {
      const w = Number(width) || 100;
      setHeight(Math.round(w / preset.ratio));
    }
  };

  const handleWidthChange = (val) => {
    setWidth(val);
    const preset = PRESETS.find((p) => p.label === activePreset);
    if (preset?.ratio) {
      setHeight(Math.round(Number(val) / preset.ratio));
    }
  };

  const handleCrop = () => {
    editor.crop({ x: Number(x), y: Number(y), width: Number(width), height: Number(height) });
  };

  return (
    <div style={panelStyle}>
      <h3 style={{ margin: '0 0 14px', fontSize: 14, color: '#ddd' }}>✂️ Crop</h3>

      {/* Aspect ratio presets */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 11, color: '#666', marginBottom: 8 }}>Aspect Ratio</div>
        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
          {PRESETS.map((p) => (
            <button
              key={p.label}
              style={presetBtnStyle(activePreset === p.label)}
              onClick={() => handlePreset(p)}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ height: 1, background: '#333', margin: '12px 0' }} />

      {/* Coordinate inputs */}
      <div style={{ fontSize: 11, color: '#666', marginBottom: 8 }}>Position & Size</div>
      <div style={rowStyle}>
        <span style={labelStyle}>X</span>
        <input type="number" min={0} value={x} onChange={(e) => setX(e.target.value)} style={inputStyle} />
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>Y</span>
        <input type="number" min={0} value={y} onChange={(e) => setY(e.target.value)} style={inputStyle} />
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>Width</span>
        <input type="number" min={1} value={width} onChange={(e) => handleWidthChange(e.target.value)} style={inputStyle} />
      </div>
      <div style={rowStyle}>
        <span style={labelStyle}>Height</span>
        <input type="number" min={1} value={height} onChange={(e) => setHeight(e.target.value)} style={inputStyle} />
      </div>

      <button style={cropBtnStyle} onClick={handleCrop}>
        Crop
      </button>
    </div>
  );
}
